import React from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import UserService from '../../../service';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ManageQueuesModal = ({
  isOpen,
  toggle,
  users,
  queues,
  setUsersForQueues
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const handleUpdateQueue = async (login, queueId, checked) => {
    if (!checked) {
      const user = users.find((u) => u.login === login);
      let promises = [];
      if (user.queuesIdToSignInChat.some((q) => q.id === queueId)) {
        promises.push(
          handleUpdateQueuesIdToSignInChat(login, queueId, false).catch(() => {
            toast.error(
              'Erro ao desmarcar "Logar automaticamente na fila de chat"!',
              {
                autoClose: 3000,
                closeOnClick: true
              }
            );
            throw new Error('Erro ao desmarcar Chat');
          })
        );
      }
      if (user.queuesidToSignIn.some((q) => q.id === queueId)) {
        promises.push(
          handleUpdateQueuesidToSignIn(login, queueId, false).catch(() => {
            toast.error(
              'Erro ao desmarcar "Logar automaticamente na fila de telefonia"!',
              {
                autoClose: 3000,
                closeOnClick: true
              }
            );
            throw new Error('Erro ao desmarcar Telephone');
          })
        );
      }

      Promise.all(promises).then(() => {
        UserService.updateUserQueue(login, {
          queueId,
          checked,
          type: 'queue'
        })
          .then(() => {
            setUsersForQueues((prev) =>
              prev.map((user) =>
                user.login === login
                  ? {
                      ...user,
                      queues: checked
                        ? [...user.queues, { id: queueId }]
                        : user.queues.filter((q) => q.id !== queueId)
                    }
                  : user
              )
            );
            toast.success('Alteração salva com sucesso!', {
              autoClose: 2000,
              closeOnClick: true
            });
          })
          .catch(() => {
            toast.error('Erro ao atualizar participação na fila!', {
              autoClose: 3000,
              closeOnClick: true
            });
          });
      });

      return;
    }

    UserService.updateUserQueue(login, {
      queueId,
      checked,
      type: 'queue'
    })
      .then(() => {
        setUsersForQueues((prev) =>
          prev.map((user) =>
            user.login === login
              ? {
                  ...user,
                  queues: checked
                    ? [...user.queues, { id: queueId }]
                    : user.queues.filter((q) => q.id !== queueId)
                }
              : user
          )
        );
        toast.success('Alteração salva com sucesso!', {
          autoClose: 2000,
          closeOnClick: true
        });
      })
      .catch(() => {
        toast.error('Erro ao atualizar participação na fila!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handleUpdateQueuesIdToSignInChat = (login, queueId, checked) => {
    return UserService.updateUserQueue(login, {
      queueId,
      checked,
      type: 'queue_to_sign_in_chat'
    })
      .then(() => {
        setUsersForQueues((prev) =>
          prev.map((user) =>
            user.login === login
              ? {
                  ...user,
                  queuesIdToSignInChat: checked
                    ? [...user.queuesIdToSignInChat, { id: queueId }]
                    : user.queuesIdToSignInChat.filter((q) => q.id !== queueId)
                }
              : user
          )
        );
        toast.success('Alteração salva com sucesso!', {
          autoClose: 2000,
          closeOnClick: true
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            'Erro ao atualizar logar automático na fila do chat!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        throw err;
      });
  };

  const handleUpdateQueuesidToSignIn = (login, queueId, checked) => {
    return UserService.updateUserQueue(login, {
      queueId,
      checked,
      type: 'queue_to_sign_in'
    })
      .then(() => {
        setUsersForQueues((prev) =>
          prev.map((user) =>
            user.login === login
              ? {
                  ...user,
                  queuesidToSignIn: checked
                    ? [...user.queuesidToSignIn, { id: queueId }]
                    : user.queuesidToSignIn.filter((q) => q.id !== queueId)
                }
              : user
          )
        );
        toast.success('Alteração salva com sucesso!', {
          autoClose: 2000,
          closeOnClick: true
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            'Erro ao atualizar logar automaticamente na fila de telefonia!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        throw err;
      });
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      style={{
        width: '80vw',
        maxWidth: '80vw',
        margin: 'auto'
      }}
    >
      <ModalHeader toggle={toggle}>Gerenciar Filas</ModalHeader>
      <ModalBody
        style={{
          overflow: 'hidden',
          position: 'relative',
          paddingTop: 56
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 8,
            right: 16,
            zIndex: 10,
            background: '#fff',
            display: 'flex',
            gap: 24,
            alignItems: 'center',
            flexWrap: 'wrap',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            borderRadius: 8,
            padding: '8px 16px'
          }}
        >
          <span>
            <input
              type="checkbox"
              checked
              readOnly
              style={{ marginRight: 4 }}
            />
            <span>Participa da fila</span>
          </span>
          <span>
            <input
              type="checkbox"
              checked
              readOnly
              style={{
                marginRight: 4,
                accentColor: systemConfiguration.primary_color || '#007bff'
              }}
            />
            <span
              style={{
                color: systemConfiguration.primary_color || '#007bff',
                fontWeight: 500
              }}
            >
              Logar automaticamente na fila de chat
            </span>
          </span>
          <span>
            <input
              type="checkbox"
              checked
              readOnly
              style={{
                marginRight: 4,
                accentColor: systemConfiguration.secondary_color || '#28a745'
              }}
            />
            <span
              style={{
                color: systemConfiguration.secondary_color || '#28a745',
                fontWeight: 500
              }}
            >
              Logar automaticamente na fila de telefonia
            </span>
          </span>
        </div>
        <div
          style={{
            overflowX: 'auto',
            overflowY: 'auto',
            width: '100%',
            maxHeight: '65vh'
          }}
        >
          <Table bordered style={{ minWidth: 800 }}>
            <thead>
              <tr>
                <th
                  style={{
                    minWidth: 180,
                    width: 180,
                    wordBreak: 'break-word',
                    maxWidth: 220,
                    position: 'sticky',
                    left: 0,
                    top: 0,
                    background: '#f8f9fa',
                    zIndex: 3
                  }}
                >
                  Usuário/Filas
                </th>
                {queues.map((queue) => (
                  <th
                    key={queue.id}
                    style={{
                      textAlign: 'center',
                      minWidth: 120,
                      maxWidth: 160,
                      width: 140,
                      wordBreak: 'break-all',
                      whiteSpace: 'normal',
                      padding: '8px',
                      position: 'sticky',
                      top: 0,
                      background: '#f8f9fa',
                      zIndex: 2
                    }}
                  >
                    {queue.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.login}>
                  <td
                    style={{
                      minWidth: 180,
                      width: 180,
                      wordBreak: 'break-word',
                      maxWidth: 220,
                      position: 'sticky',
                      left: 0,
                      background: '#fff',
                      zIndex: 2
                    }}
                  >
                    {user.nome}
                  </td>
                  {queues.map((queue) => {
                    const participaDaFila = user.queues.some(
                      (q) => q.id === queue.id
                    );
                    return (
                      <td
                        key={queue.id}
                        style={{
                          textAlign: 'center',
                          minWidth: 150,
                          maxWidth: 180,
                          width: 'auto',
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                          padding: '8px'
                        }}
                      >
                        <input
                          type="checkbox"
                          style={{ marginRight: 8 }}
                          checked={participaDaFila}
                          onChange={(e) =>
                            handleUpdateQueue(
                              user.login,
                              queue.id,
                              e.target.checked
                            )
                          }
                          title="Participa da fila"
                        />
                        <input
                          type="checkbox"
                          style={{
                            marginRight: 8,
                            accentColor: systemConfiguration.primary_color
                          }}
                          checked={user.queuesIdToSignInChat.some(
                            (q) => q.id === queue.id && queue.isChat === true
                          )}
                          onChange={(e) =>
                            handleUpdateQueuesIdToSignInChat(
                              user.login,
                              queue.id,
                              e.target.checked
                            )
                          }
                          title="Logar automaticamente na fila do chat"
                          disabled={!participaDaFila || queue.isChat !== true}
                        />
                        <input
                          type="checkbox"
                          style={{
                            accentColor: systemConfiguration.secondary_color
                          }}
                          checked={user.queuesidToSignIn.some(
                            (q) =>
                              q.id === queue.id && queue.isTelephony === true
                          )}
                          onChange={(e) =>
                            handleUpdateQueuesidToSignIn(
                              user.login,
                              queue.id,
                              e.target.checked
                            )
                          }
                          title="Logar automaticamente na fila de telefonia"
                          disabled={
                            !participaDaFila || queue.isTelephony !== true
                          }
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ManageQueuesModal;
